// extracted by mini-css-extract-plugin
export var box = "Copyright-module--box--b753e";
export var layout = "Copyright-module--layout--dce3f";
export var box_md = "Copyright-module--box_md--b0189";
export var box_xmd = "Copyright-module--box_xmd--99884";
export var box_flex = "Copyright-module--box_flex--cd127";
export var box_lg = "Copyright-module--box_lg--1b592";
export var box_sm = "Copyright-module--box_sm--1b2a9";
export var box_outer = "Copyright-module--box_outer--2fe7b";
export var box_whiteBg = "Copyright-module--box_white-bg--f84f8";
export var box_noMarginBottom = "Copyright-module--box_no-margin-bottom--ca746";
export var box_noPadding = "Copyright-module--box_no-padding--c1a87";
export var box_outerGray = "Copyright-module--box_outer-gray--26a08";
export var box_dark = "Copyright-module--box_dark--c1994";
export var box_zIndex = "Copyright-module--box_z-index--ebda1";
export var box_zIndex6 = "Copyright-module--box_z-index-6--f7d2c";
export var box_eventsWithLine = "Copyright-module--box_events-with-line--e27b2";
export var box_featuresAo = "Copyright-module--box_features-ao--d217b";
export var box_verticalPaddings = "Copyright-module--box_vertical-paddings--f9d5e";
export var clearP = "Copyright-module--clearP--2745f";
export var clearP_vc = "Copyright-module--clearP_vc--43945";
export var wrapper = "Copyright-module--wrapper--60036";
export var captcha = "Copyright-module--captcha--b9cdf";
export var fadeInAnimation = "Copyright-module--fadeInAnimation--be744";
export var placeHolderShimmer = "Copyright-module--placeHolderShimmer--09b91";